<div class="rounded-xl shadow-md p-8 max-w-7xl mx-auto">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-6">
    <div class="grid grid-cols-1 md:grid-cols-12 gap-6 items-end">
      <div class="md:col-span-4">
        <label class="block mb-1 font-medium">Setor</label>
        <p-select
          formControlName="sectorId"
          [options]="sectors"
          optionLabel="description"
          optionValue="id"
          placeholder="Selecione o setor (opcional)"
          [showClear]="true"
          class="w-full"
          styleClass="w-full"
        ></p-select>
      </div>
      <div class="md:col-span-6">
        <label class="block mb-1 font-medium">Descrição</label>
        <input
          pInputText
          formControlName="description"
          placeholder="Digite a descrição"
          class="w-full"
          [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('description') }"
        />
        <small class="text-red-500" *ngIf="isFieldInvalid('description')">Descrição é obrigatória</small>
      </div>
      <div class="md:col-span-2">
        <label class="block mb-1 font-medium">Ativo</label>
        <p-checkbox formControlName="active" [binary]="true" />
      </div>
    </div>
    <div>
      <button class="bg-orange-500 p-2 rounded-md text-white cursor-pointer" type="submit">Salvar</button>
    </div>
  </form>
</div>
